export const formatPrice = (value: string): string => 'RM' + Number(value).toFixed(2);
